export function formatMembershipBilling(type) {
  if (type.billing?.model === "one_time") {
    return type.lifetime ? "One-time / lifetime" : "One-time";
  }

  return `Subscription / ${type.billing?.interval || type.term?.unit || "year"}`;
}

export function formatMembershipTerm(type) {
  if (type.term?.unit === "lifetime" || type.lifetime) {
    return "Lifetime";
  }

  return `${type.term?.count || 1} ${type.term?.unit || "year"}`;
}
